import React from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";

function Exco1({ show, onClose, onOpen }) {
  return (
    <div>
      <div>
        <Modal
          size="lg"
          show={show}
          onHide={onClose}
          // backdrop="static"
          aria-labelledby="example-modal-sizes-title-lg"
          keyboard={false}
          animation={true}
          centered
        >
          <Modal.Body>
            <div className="Solera__Cont">
              <FiX className="Solera__Close" onClick={onClose} />
            </div>

            <div className="Exoc-Name">Josephine Appah Shode</div>
            <div className="Exco-Tittle">Vice-president 2</div>
            <br />

            <div className="Excos-Bio">
              <b> A Leader in Science Education and Mentorship*</b> Josephine
              Appah-Shode, a distinguished educator and mentor, is making waves
              in the science education community with her exceptional leadership
              and passion for fostering learning environments. <br /> <br /> Ms.
              Appah-Shode brings a wealth of experience to the table, holding
              both a BSc and MSc in Combined and General Science. Throughout her
              career, she has consistently demonstrated her commitment to the
              advancement of science education. Her leadership roles span across
              various educational landscapes, where she has been instrumental in
              establishing science departments in new colleges, contributing
              significantly to their growth and development. <br /> <br />
              One of Ms. Appah-Shode's notable achievements includes her role as
              a mentor for the pioneering programme of Early Career Teachers
              (ECTs) at UCL. Her dedication to mentoring the next generation of
              educators has earned her widespread recognition and respect within
              the academic community. <br /> <br />
              In addition to her contributions to education, Josephine
              Appah-Shode is a trailblazing member of Unilag Alumni UK, where
              she currently serves as Vice President 2 in the Executive
              Committee. Her proactive involvement and strategic vision have
              been instrumental in driving the organization's mission forward.{" "}
              <br /> <br />
              As a passionate advocate for science education and mentorship,
              Josephine Appah-Shode continues to inspire and empower educators
              and students alike, leaving a lasting impact on the field
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default Exco1;
